import React, {useState} from 'react';
import {Formik} from 'formik';
import styled from 'styled-components';
import {withStyles} from '@material-ui/core/styles';
import Headline from '../../../components/Typography/Headline';
import Body from '../../../components/Typography/Body';
import FormGrid from '../../../components/Form/FormGrid';
import TextField from '@material-ui/core/TextField';
import {PrimaryButton, ButtonRow} from '../../../components/Buttons';
import {Caption1, Title2} from '../../../components/Typography';
import Dialog from '@material-ui/core/Dialog';

const styles = theme => ({
  scrollPaper: {
    alignItems: 'flex-start',
    // typeof window !== 'undefined' && window.innerWidth < 786
    //   ? 'flex-end'
    //   : 'center',
  },
  paper: {
    margin: 0,
    maxWidth: '100%',
  },
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const Wrapper = styled.div`
  display: grid;
  grid-gap: 20px;
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const FormLayout = styled(FormGrid)`
  grid-gap: 20px;
`;

const CheckEmailForm = ({
  isRequesting,
  checkEmail,
  hideAuthenticationModal,
  classes,
}) => {
  const isEmail = new RegExp(
    '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@' +
      '[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
  );

  return (
    <Wrapper>
      <TitleWrapper>
        <Headline id="EmailForm-WelcomeHeadline">Sign In</Headline>
        <Cancel id="EmailForm-Cancel" onClick={hideAuthenticationModal}>
          <i className="fal fa-times" />
        </Cancel>
      </TitleWrapper>
      <Body id="EmailForm-Message">
        Whether you’re creating an account or signing back in, let’s start with
        your email
      </Body>
      <Formik
        initialValues={{email: ''}}
        validate={values => {
          let errors = {};
          if (!values.email) {
            errors.email = 'Required';
          } else if (!isEmail.test(values.email)) {
            errors.email = 'Please put a valid email format';
          }
          return errors;
        }}
        onSubmit={values => checkEmail(values)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FormLayout>
              <TextField
                id="EmailForm-Username"
                label="Email"
                name="email"
                type="email"
                autoComplete="username"
                value={values.email}
                onChange={handleChange}
                required
                onBlur={handleBlur}
                error={touched.email && errors.email ? true : false}
                helperText={touched.email && errors.email}
                InputLabelProps={{
                  className: classes.input,
                  required: false,
                }}
              />
              <ButtonRow justifyContent="center">
                <PrimaryButton
                  id="EmailForm-Submit"
                  type="submit"
                  disabled={isRequesting}
                >
                  Proceed
                </PrimaryButton>
              </ButtonRow>
            </FormLayout>
          </form>
        )}
      </Formik>
    </Wrapper>
  );
};

export default withStyles(styles)(CheckEmailForm);
